import {
  ReportPatientReportType,
  ReportTimeInterval,
  Option,
  IReportIntrospection,
  paths,
} from '@common/types';

type GroupByFilter = { group_by?: string };

export type IPatientsPreviewFilters = Partial<
  paths['/reporting/patients/reports/preview']['get']['parameters']['query']
> &
  GroupByFilter;
export type ITasksPreviewFilters = Partial<
  paths['/reporting/tasks/reports/preview']['get']['parameters']['query']
> &
  GroupByFilter;
export type IRecordsPreviewFilters = Partial<
  paths['/reporting/record/reports/preview']['get']['parameters']['query']
> &
  GroupByFilter;
export type IUsersPreviewFilters = Partial<
  paths['/reporting/users/reports/preview']['get']['parameters']['query'] &
    GroupByFilter
>;

export type IPreviewTableFilters = Partial<
  | IRecordsPreviewFilters
  | IPatientsPreviewFilters
  | ITasksPreviewFilters
  | IUsersPreviewFilters
>;

export type IPreviewTableEntry = Partial<
  | paths['/reporting/record/reports/preview']['get']['responses']['200']['content']['application/json']['items'][0]
  | paths['/reporting/tasks/reports/preview']['get']['responses']['200']['content']['application/json']['tasks'][0]
  | paths['/reporting/patients/reports/preview']['get']['responses']['200']['content']['application/json']['patients'][0]
  | paths['/reporting/users/reports/preview']['get']['responses']['200']['content']['application/json']['users'][0]
>;

export const patientReportTypeOptions: Option[] = [
  { value: ReportPatientReportType.ALL_PATIENTS, label: 'All patients' },
  { value: ReportPatientReportType.MY_PATIENTS, label: 'My patients' },
  {
    value: ReportPatientReportType.MY_TEAMS_PATIENTS,
    label: "My team's patients",
  },
];

export const reportTimeIntervalOptions: Option[] = [
  { value: ReportTimeInterval.ALL_TIME, label: 'All time' },
  { value: ReportTimeInterval.CUSTOM, label: 'Custom' },
  { value: ReportTimeInterval.LAST_YEAR, label: 'Last year' },
  { value: ReportTimeInterval.THIS_YEAR, label: 'This year' },
  { value: ReportTimeInterval.LAST_QUARTER, label: 'Last quarter' },
  { value: ReportTimeInterval.THIS_QUARTER, label: 'This quarter' },
  { value: ReportTimeInterval.LAST_MONTH, label: 'Last month' },
  { value: ReportTimeInterval.THIS_MONTH, label: 'This month' },
  {
    value: ReportTimeInterval.CURRENT_AND_PREVIOUS_MONTH,
    label: 'Current and previous month',
  },
  { value: ReportTimeInterval.LAST_WEEK, label: 'Last week' },
  { value: ReportTimeInterval.THIS_WEEK, label: 'This week' },
  { value: ReportTimeInterval.YESTERDAY, label: 'Yesterday' },
  { value: ReportTimeInterval.TODAY, label: 'Today' },
  { value: ReportTimeInterval.LAST_7_DAYS, label: 'Last 7 days' },
  { value: ReportTimeInterval.LAST_30_DAYS, label: 'Last 30 days' },
  { value: ReportTimeInterval.LAST_60_DAYS, label: 'Last 60 days' },
  { value: ReportTimeInterval.LAST_90_DAYS, label: 'Last 90 days' },
  { value: ReportTimeInterval.LAST_120_DAYS, label: 'Last 120 days' },
];

export const operatorLabels: Record<
  IReportIntrospection['filters'][0]['operators'][0],
  string
> = {
  $eq: 'Equals',
  $like: 'Contains',
  $ilike: 'Contains (case-insensitive)',
  $in: 'In list',
  $isnull: 'Is empty',
  $neq: 'Not equal',
  $nlike: 'Does not contain',
  $nilike: 'Does not contain (case-insensitive)',
  $nin: 'Not in list',
};
